import { MultiValuedList } from '../../MultiValuedList'
import { TextMultiValuedListItem } from '../../TextMultiValuedList'
import { BuildingGroupMultiValuedListMoreItem } from '../BuildingGroupMultiValuedListMoreItem'

import { filterByChildren } from './BuildingGroupMultiValuedList.utils'

function BuildingGroupMultiValuedList({
  Item = TextMultiValuedListItem,
  MoreItem = BuildingGroupMultiValuedListMoreItem,
  filter = filterByChildren,
  ...restProps
}) {
  return (
    <MultiValuedList
      {...restProps}
      Item={Item}
      MoreItem={MoreItem}
      filter={filter}
    />
  )
}

export default BuildingGroupMultiValuedList
